__turbopack_context__.v({
  "bodyIntro": "page-module__lwRYeG__bodyIntro",
  "breadcrumbs": "page-module__lwRYeG__breadcrumbs",
  "calculatorField": "page-module__lwRYeG__calculatorField",
  "calculatorFieldImage": "page-module__lwRYeG__calculatorFieldImage",
  "calculatorFieldImageWrap": "page-module__lwRYeG__calculatorFieldImageWrap",
  "calculatorFieldLabel": "page-module__lwRYeG__calculatorFieldLabel",
  "calculatorFieldWarning": "page-module__lwRYeG__calculatorFieldWarning",
  "calculatorGrid": "page-module__lwRYeG__calculatorGrid",
  "calculatorInput": "page-module__lwRYeG__calculatorInput",
  "calculatorPrompt": "page-module__lwRYeG__calculatorPrompt",
  "calculatorResultColumn": "page-module__lwRYeG__calculatorResultColumn",
  "calculatorResultLabel": "page-module__lwRYeG__calculatorResultLabel",
  "calculatorResultValue": "page-module__lwRYeG__calculatorResultValue",
  "calculatorResults": "page-module__lwRYeG__calculatorResults",
  "calculatorRow": "page-module__lwRYeG__calculatorRow",
  "calculatorSelect": "page-module__lwRYeG__calculatorSelect",
  "calculatorWrapper": "page-module__lwRYeG__calculatorWrapper",
  "container": "page-module__lwRYeG__container",
  "eyebrow": "page-module__lwRYeG__eyebrow",
  "h265ArticleBody": "page-module__lwRYeG__h265ArticleBody",
  "h265ArticleDivider": "page-module__lwRYeG__h265ArticleDivider",
  "h265ArticleImage": "page-module__lwRYeG__h265ArticleImage",
  "h265ArticleRow": "page-module__lwRYeG__h265ArticleRow",
  "h265ArticleSection": "page-module__lwRYeG__h265ArticleSection",
  "hero": "page-module__lwRYeG__hero",
  "heroBody": "page-module__lwRYeG__heroBody",
  "heroCtaParagraph": "page-module__lwRYeG__heroCtaParagraph",
  "heroInner": "page-module__lwRYeG__heroInner",
  "heroPrimaryCta": "page-module__lwRYeG__heroPrimaryCta",
  "heroTitle": "page-module__lwRYeG__heroTitle",
  "manifestOnly": "page-module__lwRYeG__manifestOnly",
  "page": "page-module__lwRYeG__page",
  "partnerAside": "page-module__lwRYeG__partnerAside",
  "relatedGuide": "page-module__lwRYeG__relatedGuide",
  "relatedGuideBody": "page-module__lwRYeG__relatedGuideBody",
  "relatedGuideLead": "page-module__lwRYeG__relatedGuideLead",
  "relatedGuides": "page-module__lwRYeG__relatedGuides",
  "relatedGuidesDivider": "page-module__lwRYeG__relatedGuidesDivider",
  "substreamArticleSection": "page-module__lwRYeG__substreamArticleSection",
  "visuallyHidden": "page-module__lwRYeG__visuallyHidden",
});
